export default "//yastatic.net/s3/distribution/pythia/frontend/_/dc22035515a39813625103f0fca53835.png";